import { useState, useEffect } from "react";
import "./LuckyGame.css";
import Wheel from "./Wheel";
import RestrictionCard from "./RestrictionCard";
import baseUrl from "../../url/baseUrl";
import RingLoader from "react-spinners/RingLoader";

const LuckyGame = () => {
  const [result, setResult] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isGameOver, setIsGameOver] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkGameOver();
  }, []);

  const checkGameOver = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${baseUrl}/api/check-zero-quantities`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không kiểm tra được số lượng quà");
      }

      setIsGameOver(data.data === true);
    } catch (error) {
      console.error(error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSpinResult = (message) => {
    setResult(message);
    setIsPopupVisible(true);
  };

  const closePopup = async () => {
    setIsPopupVisible(false);
    await checkGameOver();
  };

  return (
    <div id="wrapper">
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <RingLoader color="#ffc107" />
        </div>
      ) : (
        <>
          {isGameOver ? (
            <RestrictionCard />
          ) : (
            <Wheel onSpinResult={handleSpinResult} />
          )}

          {isPopupVisible && (
            <div className="popup-overlay">
              <div className="popup-content bg-warning">
                <div>
                  <h2 className="text-primary">Bạn đã trúng thưởng:</h2>

                  <p
                    className="text-danger fw-bold fs-4"
                    style={{ fontFamily: "tahoma" }}
                  >
                    {result?.prize}
                  </p>
                </div>

                <button onClick={closePopup}>Close</button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LuckyGame;
